import React, { useState } from 'react';
import useAPI from '../../../hooks/useAPI';
import useErrors, { useError } from '../../../hooks/useErrors';
import FormInput from '../../FormInput';
import RoundedButton from '../../RoundedButton';

export default function SMSAuth ({ trusttoken, onSuccess, last4 }) {
    const [secret, setSecret] = useState('');
    const [secretError, setSecretError] = useState('');
    const [sendingSecret, setSendingSecret] = useState(false);

    const api = useAPI();
    const errors = useErrors();
    const error = useError();

    const sendSecret = () => {
        setSendingSecret(true);
        setSecretError('');

        api.json('POST', '/auth/complete-sms-challenge', {
            secret,
            trust_token: trusttoken
        })
            .then(r => r.json())
            .then(r => {
                if (r.errors) {
                    if (r.errors.secret) {
                        return setSecretError(r.errors.secret[0]);
                    }
                    return errors(r.errors);
                }

                if (!r.data?.auth) {
                    error('An unknown error has occurred. Please try again later.');
                }

                onSuccess(r.data);
            })
            .catch((e) => {
                alert(e);
            })
            .finally(() => setSendingSecret(false)); // Use `finally` for cleanup
    };

    return (
        <>
            <ol style={{ listStyleType: 'numbered', padding: '15px', lineHeight: 1.4 }}>
                <li>We sent a verification code to the number (***) *** {last4}.</li>
                <li>Enter code to verify account ownership.</li>
            </ol>

            <div style={{ display: 'flex', flexDirection: 'row', gap: 10, justifyContent: 'center', margin: '10px 0' }}>
                <FormInput
                    value={secret}
                    disabled={sendingSecret}
                    maxLength="6"
                    placeholder="Enter Code"
                    onChange={(e) => setSecret((e.target.value + '').replace(/[^0-9]+/g, ''))}
                    error={secretError}
                />
                <span>
                    <RoundedButton 
                        disabled={secret.length < 6 || sendingSecret} 
                        onClick={()=>sendSecret()}
                        solid
                    >
                        Submit
                    </RoundedButton>
                </span>
            </div>
        </>
    );
};